import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getSectorProviders } from '../../services/sectors'

const RANKING_DICTIONARY = {
  amount: 'indexAmount',
  name: 'indexName',
  oc: 'indexOC',
  prov: 'indexProv',
  rut: 'indexRut'
}

export const GET_SECTOR_PROVIDERS = 'GET_SECTOR_PROVIDERS'
export const GET_SECTOR_PROVIDERS_ERROR = 'GET_SECTOR_PROVIDERS_ERROR'
export const GET_SECTOR_PROVIDERS_SUCCESS = 'GET_SECTOR_PROVIDERS_SUCCESS'
export const onGetSectorProviders = makeActionCreator(GET_SECTOR_PROVIDERS)
export const onGetSectorProvidersError = makeActionCreator(GET_SECTOR_PROVIDERS_ERROR, 'payload')
export const onGetSectorProvidersSuccess = makeActionCreator(GET_SECTOR_PROVIDERS_SUCCESS, 'payload')
export const onGetSectorProvidersThunk = payload => async dispatch => {
  dispatch(onGetSectorProviders())

  try {
    const { data } = await getSectorProviders({
      direction: payload.direction,
      mechanismId: payload.mechanismId,
      order: payload.order,
      page: payload.page,
      sectorId: payload.id,
      year: payload.year
    })
    const enhancedData = data.payload?.resultados?.map(item => ({
      amount: item.amountCLP,
      amountUSD: item.amountUSD,
      dni: item.rutSupplier,
      name: item.supplier,
      orders: item.quantityOC,
      ranking: item[RANKING_DICTIONARY[payload.order]] || null
    }))

    return batch(() => {
      dispatch(
        onGetSectorProvidersSuccess({
          data: enhancedData,
          page: data.payload?.page || 1,
          pages: data.payload?.pageCount || 1,
          records: data.payload?.resultCount || 1
        })
      )
      payload.callback && payload.callback()
    })
  } catch (error) {
    return dispatch(onGetSectorProvidersError({ error }))
  }
}
